



























import { Component, Vue } from 'vue-property-decorator'

import StandmansChart from "@/components/lfs/Statistics/Items/StandmansChart.vue"
import StandmansTable from "@/components/lfs/Statistics/Items/StandmansTable.vue"
import Chips from "@/components/lfs/Statistics/Items/Chips.vue"
import colors from "@/assets/colors.json"

@Component({
  name: 'c-standmans',

  components: {
    'c-standmans-chart': StandmansChart,
    'c-standmans-table': StandmansTable,
    'c-chips': Chips
  }
})
export default class Standmans extends Vue {
  colorsArr: string[] | null = null
  isShow: boolean = false
  checkedTableItem: number[] = [1, 3]

  get standmans () {
    return this.$store.getters["statistics/getStandmans"]
      .sort((a: any, b: any) => {
        let aName = `${a.name.first} ${a.name.second}`
        let bName = `${b.name.first} ${b.name.second}`

        return aName > bName ? 1 : -1
      })
      .map((a: any, index: number) => {
        a.color = colors[index]

        return a
      })
  }

  get isUpdated () {
    return this.$store.getters["statistics/getUpdateStatus"];
  }

  get checkedStandmans () {
    let checked: any[] = []

    this.standmans.map((item: any, id: number) => {
      if (this.checkedTableItem.indexOf(item._id) != -1) {
        checked.push({
          id,
          name: `${item.name.first} ${item.name.last}`,
          data: item.forHours.map((el: any) => [el.time * 1000, el.total]),
          color: item.color
        })
      }
    })

    checked.forEach(item => {
      item.data.sort(function(a: any, b: any) {
        return a[0] - b[0]
      })
    })

    return checked
  }

  onChangeTableItem (e: any): void {
    this.checkedTableItem = e
  }

  mounted (): void {
    this.isShow = true
  }
}
